// Story 213 — several tabs of the same session (DP-15, RN23.1): only one sends frames, and it broadcasts
// every state it receives to the others.

export const VISION_CHANNEL_NAME = 'mic-vision'
const EMITTER_LOCK_NAME = 'mic-vision-emitter'

export const openVisionChannel = (onState) => {
  if (typeof window.BroadcastChannel !== 'function') {
    return { post: () => {}, close: () => {} }
  }
  const channel = new window.BroadcastChannel(VISION_CHANNEL_NAME)
  channel.onmessage = (event) => onState(event.data)
  return {
    // C7.1: the message is the DTO as received.
    post: (dto) => channel.postMessage(dto),
    close: () => channel.close()
  }
}

/**
 * Runs `emit` while this tab holds the emitter lock: a tab waits until no other tab of the browser
 * emits, so one sends at a time and another takes over when it closes. Without the Web Locks API the
 * tab emits directly.
 */
export const runAsEmitter = async (signal, emit) => {
  if (!navigator.locks || typeof navigator.locks.request !== 'function') {
    return emit()
  }
  try {
    await navigator.locks.request(EMITTER_LOCK_NAME, { signal }, () => emit())
  } catch (exception) {
    if (!exception || exception.name !== 'AbortError') {
      throw exception
    }
  }
}
